module.exports = __webpack_public_path__ + "img/cubism.54ce1043.png";